import { useEffect, useState } from 'react';

export function readColorMode() {
  if (typeof document === 'undefined') return 'dark';
  return document.body.classList.contains('light-mode') ? 'light' : 'dark';
}

export function chartTheme(mode = readColorMode()) {
  if (mode === 'light') {
    return {
      tick: 'rgba(15, 23, 42, 0.58)',
      axis: 'rgba(15, 23, 42, 0.45)',
      grid: 'rgba(15, 23, 42, 0.10)',
      hover: 'rgba(15, 23, 42, 0.28)',
      zero: 'rgba(15, 23, 42, 0.16)',
    };
  }
  return {
    tick: 'rgba(255, 255, 255, 0.64)',
    axis: 'rgba(255, 255, 255, 0.5)',
    grid: 'rgba(255, 255, 255, 0.08)',
    hover: 'rgba(255, 255, 255, 0.32)',
    zero: 'rgba(255, 255, 255, 0.1)',
  };
}

/** Re-renders when `body` gains or loses `light-mode`. */
export function useColorMode() {
  const [mode, setMode] = useState(readColorMode);
  useEffect(() => {
    const sync = () => setMode(readColorMode());
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);
  return mode;
}
